export interface ContratoAfilmedDTO {
  /** Si el servicio de contratos lo envía, PK para desambiguar duplicados al radicar. */
  idContratoOrigen?: number | string;
  ID_CONTRATO_ORIGEN?: number | string;
  idContrato?: number | string;
  IdContrato?: number | string;
  contrato: string;
  EstadoContrato: string;
  TipoPlan: string;
  ProgramaCodigo: string;
  ProgramaNombre: string;
  /** Servicio contratos-user: `cuenta` (ej. `2 - FAMILIAR`). */
  cuenta?: string;
  /** Alias legacy; el API suele enviar solo `cuenta`. */
  Cuenta?: string;
  NombreCuenta?: string;
  DiaCorte: number;
  CodigoTarifa: string;
  /** Afilmed puede enviarlo como string; el front lo normaliza a número. */
  SaldoEnMora: number | string;
  AsesorPoblacion: string;
  AsesorGestion: string;
  Contratante: string;
  TelefonoCelular: string;
  TelefonoFijo: string;
  EmailContratante: string;
  Regional: string;
  Sucursal: string;
  ColectivoEspecial: string | null;
  LineaNegocio: string;
  GrupoPrograma: string;
  TipoCuenta: string;
  TipoSubCuenta: string;
  TipoPrima: string | null;
  Nit: string | null;
  fecha_inicio: string;
  fecha_vigencia: string;
  fecha_baja: string;
}

/** Texto de cuenta del contrato Afilmed (`cuenta` del API o `Cuenta` legacy). */
export function leerCuentaAfilmed(
  contrato: Pick<ContratoAfilmedDTO, 'cuenta' | 'Cuenta'> | null | undefined,
): string {
  if (!contrato) {
    return '';
  }
  return String(contrato.cuenta ?? contrato.Cuenta ?? '').trim();
}
